export default "__VITE_ASSET__BtI1Xmx$__"